import React, { useEffect } from 'react';

interface ContactFormProps {
  embedCode: string;
  className?: string;
  formId: string;
}

const ContactForm = ({
  embedCode,
  className = 'contact-us-form',
  formId = 'hubspot-form-container',
}: ContactFormProps) => {
  useEffect(() => {
    const container = document.getElementById(formId);
    if (container) {
      // inject the HTML
      container.innerHTML = embedCode;

      // re-run any <script> tags inside embedCode
      const scripts = container.getElementsByTagName('script');
      for (let i = 0; i < scripts.length; i += 1) {
        const script = document.createElement('script');
        script.src = scripts[i].src || '';
        script.innerHTML = scripts[i].innerHTML;
        script.async = true;
        document.body.appendChild(script);
      }
    }
  }, [embedCode]);

  return <div className={className} id={formId} />;
};

export { ContactForm };
